import AOS from 'aos';
// import gsap from 'gsap';
// import SmoothScroll from 'smoothscroll-for-websites';
// import smoothscroll from 'smoothscroll-polyfill';
import Gradient from './Gradient';
import Slide from './Slide';
import Menu from './Menu';

import FormConfig from './formConfig/formConfig';
// import FormConfig from './formConfig/formConfigFile';

window.onload = () => {
    // smoothscroll.polyfill();
    // SmoothScroll({
    //     stepSize: 80,
    //     accelerationMax: 10,
    //     animationTime: 1000,
    // });

    const gradient = new Gradient();
    gradient.initGradient('#gradient-canvas');
    const menu = new Menu(); // eslint-disable-line

    const form = new FormConfig(); // eslint-disable-line

    const sl = new Slide(); // eslint-disable-line

    setTimeout(() => {
        AOS.init({
            once: true,
        });
    }, 1);

    if (document.querySelector('.summary_link')) {
        Array.from(document.querySelectorAll('.summary_link')).forEach((item) => {
            item.addEventListener('click', () => {
                if (item.getAttribute('href') !== '' && document.querySelector(item.getAttribute('href'))) {
                    document.querySelector(item.getAttribute('href')).scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
            });
        });
    }
};
